module.exports = __webpack_public_path__ + "img/d960bce.jpg";